import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 21
class PrintReportWaitingQuotation extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.customerType!=undefined&&this.props.q!=undefined) {
            ReportStore.loadReportPendingApprovedQuotation(this.props.customerType,this.props.q,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value,digit=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={12}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
              <td className='text-center'>{(indexs*20)+index+1}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.claim_no}</td>
              <td className='text-center'>{item.insurer_name}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.fixing_count}</td>
              <td className='text-right'>{this.getNumberFormat(item.wage_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.part_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_wage)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_part)}</td>
              <td className='text-center'>{item.entrance_date}</td>
              <td className='text-center'>{item.appointment_date}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        // let {type} = this.props
        return(
            <table className='table table-print-report-fixing'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'20px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'80px'}}>เลขที่<br/>ใบสั่งซ่อม</td>
                        <td className='text-center' style={{width:'80px'}}>เลขที่เคลม<br/>หมายเลขแจ้ง</td>
                        <td className='text-center' style={{width:'110px'}}>ประกันภัย</td>
                        <td className='text-center' style={{width:'90px'}}>เลขทะเบียน</td>
                        <td className='text-center' style={{width:'90px'}}>จำนวน<br/>รายการซ่อม</td>
                        <td className='text-center' style={{width:'90px'}}>ราคา<br/>เสนอค่าแรง</td>
                        <td className='text-center' style={{width:'90px'}}>ราคา<br/>เสนอค่าอะไหล่</td>
                        <td className='text-center' style={{width:'90px'}}>ราคา<br/>อนุมัติค่าแรง</td>
                        <td className='text-center' style={{width:'90px'}}>ราคา<br/>อนุมัติค่าอะไหล่</td>
                        <td className='text-center' style={{width:'80px'}}>วันที่รับรถเข้า</td>
                        <td className='text-center' style={{width:'80px'}}>วันที่นัดส่งรถ</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td colSpan={5} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('fixing_count'),0)}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wage_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('part_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('approved_wage'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('approved_part'))}</td>
                        <td colSpan={2} className='text-right'></td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length===0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportWaitingQuotation.defaultProps = {
    title: 'ตารางรายงานงานซ่อมรอส่งเรื่อง',
    mode: '',
    workNo: ''
  }
  export default PrintReportWaitingQuotation;


// WEBPACK FOOTER //
// ./src/view/print/fixing/PrintReportWaitingQuotation.js